import { useState } from 'react'
import styled from '@emotion/styled'
import { Tooltip } from '@mui/material'
import { SubmissionError } from '@global/types'
import { t } from '@lingui/core/macro'

const ClickableSpan = styled.span`
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`

type TooltipTitle = string

interface Props {
  errorCodeText: string
  error: SubmissionError
}

export const ErrorCodeTextCopyable = ({ errorCodeText, error }: Props) => {
  const { id, error_phase, message, submission_id, type_code } = error
  const [title, setTitle] = useState<TooltipTitle>(t`Copy exception to clipboard`)
  const copyableErrorObj = {
    id,
    error_phase,
    message,
    submission_id,
    type_code,
  }

  return (
    <Tooltip
      arrow
      title={title}
      placement="top"
      onOpen={() => {
        resetTitle()
      }}
    >
      <ClickableSpan
        onClick={() => {
          void copyToClipboard(copyableErrorObj)
        }}
        aria-hidden="true"
      >
        {errorCodeText}
      </ClickableSpan>
    </Tooltip>
  )

  async function copyToClipboard(obj) {
    const text = JSON.stringify(obj, null, '\t')
    await navigator.clipboard.writeText(text)
    setTitle(t`Copied!`)
  }

  function resetTitle() {
    setTitle(t`Copy exception to clipboard`)
  }
}
